import Box from "@memorang/ui/components/Box";
import { ActivityLogCard } from "@memorang/ui/components/Cme/ActivityLogCard";
import { CMESummaryCard } from "@memorang/ui/components/Cme/CMESummaryCard";
import CMETypeCard from "@memorang/ui/components/Cme/CMETypeCard";
import { ConfirmDialog } from "@memorang/ui/components/ConfirmDialog";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { useRouter } from "expo-router";
import { useState } from "react";
import {
	CME_TYPES,
	cmeDisclaimerDialogConfig,
	mockActivityLog,
	mockCmeSummary,
} from "../constants";

const CME_TYPE_IMAGE_URI =
	"https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=80&h=80&fit=crop";

export const CMEContainer = () => {
	const router = useRouter();
	const [showDisclaimer, setShowDisclaimer] = useState(true);

	const handleDismissDisclaimer = () => {
		setShowDisclaimer(false);
	};

	const handleConfirmDisclaimer = () => {
		setShowDisclaimer(false);
		router.push("/cme/disclaimer?showBack=true");
	};

	return (
		<>
			<ScrollContainer maxWidth="sm">
				<Box gap={16} padding={16}>
					<CMETypeCard
						title={CME_TYPES[0].title}
						subtitle={CME_TYPES[0].subtitle}
						imageUri={CME_TYPE_IMAGE_URI}
						onPress={() => router.push("/cme/disclaimer")}
					/>
					<CMESummaryCard
						earnedCredits={mockCmeSummary.earnedCredits}
						remainingCredits={mockCmeSummary.remainingCredits}
						onExportPress={() => router.push("/cme/export")}
					/>
					<ActivityLogCard
						title="Activity Log"
						subtitle="Based on your recent challenge activity"
						icon="view-list-outline"
						items={mockActivityLog}
						onItemPress={() => router.push("/cme/log")}
						onViewAll={() => router.push("/cme/log")}
					/>
				</Box>
			</ScrollContainer>

			<ConfirmDialog
				{...cmeDisclaimerDialogConfig}
				visible={showDisclaimer}
				dismissCallback={handleDismissDisclaimer}
				confirmCallback={handleConfirmDisclaimer}
			/>
		</>
	);
};
